import styled from 'styled-components';
import Link from 'next/link';
import Image from 'next/image';
import {getColor} from "@/styles/ThemeConfig";
import Stars from "@/components/base/Stars";
import {Button} from "@/components/base/Buttons";
import {breakpoints} from "@/styles/sizes";
import ForceSSRLink from "@/components/other/ForceSSRLink";


// Styled Components
const CardContainer = styled.div`
    cursor: pointer;

    overflow: hidden;

    min-width: 100%;
    width: 100%;
    max-width: 375px;
    @media only screen and (${breakpoints.mobile}) {
        width: 290px;

    }

    background-color: #f5faff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    position: relative;
    padding-bottom:100px;
`;

const CardImage = styled(Image)`
  width: 100%;
  height: 250px;
  object-fit: cover;
`;

const CardContent = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding: 10px;
`;

const RatingContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;

const RatingDetails = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;


const Title = styled.div`
  padding: 5px 5px 15px 0;
  font-family: 'Playfair Display';
  font-size: 23px;
`;

const Description = styled.p`
  font-size: 14px;
  color: #666;
`;


const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
    
    position: absolute;
    bottom:30px;
    left:10px;
`;

// Main Component
export default function HistoricalTourCard({
                                         rating,
                                         title,
                                         description,
                                         buttonText,
                                         buttonLink,
                                         image,
                                         ...rest
}) {
    return (
            (rating &&
            title &&
            description &&
            buttonText &&
            buttonLink &&
            image) && <CardContainer {...rest}>
                <ForceSSRLink href={buttonLink ?? '#'}>
                    <CardImage src={image?.url} alt={title} width="400" height="250" />
                </ForceSSRLink>

                <CardContent>
                    <RatingContainer>
                        <RatingDetails>
                            <Stars style={{color: getColor('yellow')}} numOfStars={rating} size={25}/>
                            <span style={{
                                fontSize: '14px',
                                paddingLeft: '10px',
                                paddingTop: '3px',
                                color: 'gray'
                            }}>({rating})</span>
                        </RatingDetails>

                    </RatingContainer>

                    <Title>{title}</Title>
                    <Description dangerouslySetInnerHTML={{__html: ((description || "").replace(/<\/?[^>]+(>|$)/g, ""))}}/>


                    <ButtonsContainer>
                        <Button variant={'blue'} href={buttonLink ?? '#'}>{buttonText}</Button>
                    </ButtonsContainer>
                </CardContent>
            </CardContainer>
    );
}
